<template>
	<div class="ultra-processing-list">
		<div class="ultra-processing-con">
			<div class="title">
				<i class="x-icon-keys"></i><span class="x-tit-con">Ultra short pulse laser processing technology and integrated equipment</span>
			</div>

			<div class="list">
				<ul class="tt">
					<li><img :src="solution_image_01"/></li>
					<li><img :src="solution_image_02"/></li>
				</ul>
				<div class="un-tt">
					<p>
						Research on ultra short pulse laser micro nano machining technology and its application integrated equipment based on the fast trumicro 5000 Series picosecond laser, including:</p>
					<ul class="dd">
						<li>
							<div class="dot x-flow">·</div>
							<div class="ll x-flow">
								Laser cutting technology and integrated equipment for the production and processing of brittle and hard
								materials  which applied to prooduct sapphire watch covers of our company;
							</div>
						</li>
						<li>
							<div class="dot x-flow">·</div>
							<div class="ll x-flow">
								Laser micro deep hole processing technology and application equipment, used in spinneret, filter head and other micro nano applications.
							</div>
						</li>
						<li>
							<div class="dot x-flow">·</div>
							<div class="ll x-flow">
								Laser micro carving processing technology and application equipment。 Take the advantage of the small thermal
								effect of ultrashort pulse laser, complex two-dimensional code is carved on the end face of the tool, which can still
								maintain high resolution and assist CNC workshop tool management.
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import solution_image_01 from '@/assets/resource/images/solution/image_solutions_ime_05.png'
    import solution_image_02 from '@/assets/resource/images/solution/image_solutions_ime_06.png'
    export default {
        data(){
            return {
                solution_image_01: solution_image_01,
                solution_image_02: solution_image_02,
            };
        }
    }

</script>

<style scoped="">
		.dot {
			width: .625rem;
			text-align: left;
		}

		.ll {
			font-size: 1rem;
			color: #515555;
			letter-spacing: 0;
			text-align: justify;
			line-height: 1.75rem;
			width: calc(100% - .625rem);
			margin-bottom: 1.375rem;
		}

		.dd > li {
			width: 100%;
		}

		.dd {
			width: 100%;
		}

		.un-tt > p {
			width: 100%;
			font-size: 1rem;
			color: #515555;
			letter-spacing: 0;
			text-align: justify;
			line-height: 1.75rem;
			margin-bottom: 2.75rem;
		}

		.un-tt {
			width: 100%;
			height: 21rem;
		}

		.tt img {
			width: 100%;
			height: 100%;
		}

		.tt > li:nth-child(2) {
			width: calc(100% - 29.75rem - 1.5rem);
			margin-left: 1.5rem;
		}

		.tt > li:nth-child(1) {
			width: 29.75rem;
		}

		.tt > li {
			height: 20rem;
			float: left;
		}

		.tt {
			width: 100%;
			height: 20rem;
			margin-bottom: 2.75rem;
		}

		.ultra-processing-con {
			width: 61.5rem;
			border: none;
			margin-left: 0px;
		}

		.ultra-processing-list {
			width: 100%;
			height: 50.4375rem;
			border: none;
		}

		.x-tit-con {
			font-size: 1.5rem;
			color: #3B3A38;
			line-height: 3.25rem;
		}

		.list {
			width: 54.5rem;
			height: 34.5rem;
			border: none;
			margin-left: 7rem;
		}

		.title {
			width: calc(100% - 3.25rem);
			text-align: left;
			margin-left: 3.25rem;
			margin-top: 2.75rem;
			margin-bottom: 2.74rem;
		}

		.x-icon-keys {
			display: inline-block;
			content: url("../../../assets/resource/icons/ico_solutions.png");
			width: 2.75rem;
			height: 2.75rem;
			position: relative;
			top: .625rem;
			margin-right: 1rem;
		}
</style>


// WEBPACK FOOTER //
// src/components/zh-cn/solution/solution-ultra-processing-equipment.vue